import { render, staticRenderFns } from "./Premises.vue?vue&type=template&id=40207c1a&"
import script from "./Premises.vue?vue&type=script&lang=js&"
export * from "./Premises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports